export const FILE_SIZE_LIMIT_IN_MEGABYTES = 100;
export const FILE_SIZE_LIMIT_IN_BYTES =
  FILE_SIZE_LIMIT_IN_MEGABYTES * 1024 * 1024;

export const SUPPORTED_MIME_TYPES = {
  'text/html': 'html',
  'application/pdf': 'pdf',
  'application/vnd.google-apps.document': 'pdf',
  'application/vnd.google-apps.presentation': 'pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'pptx',
  'application/msword': 'doc',
};

export const ALLOWED_MIME_TYPES = Object.keys(SUPPORTED_MIME_TYPES);
export const ALLOWED_FILE_EXTENSIONS = [
  ...new Set(Object.values(SUPPORTED_MIME_TYPES)),
];
